import { ReactElement, ReactNode, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";

export interface InfoTipProps {
  message: ReactNode;
  label?: string;
}

export const InfoTip = ({
  message,
  label = "Show method details",
}: InfoTipProps): ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      arrow
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      title={message}
      placement="top"
      slotProps={{ tooltip: { sx: { maxWidth: 360, fontSize: "0.78rem", lineHeight: 1.45 } } }}
    >
      <IconButton
        aria-label={label}
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          setOpen((current) => !current);
        }}
        sx={{ p: 0.35, color: "text.secondary" }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Tooltip>
  );
};

export interface MethodInfoProps extends InfoTipProps {
  title: string;
}

const MethodInfo = ({ title, message, label }: MethodInfoProps): ReactElement => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
    <Typography variant="subtitle2" sx={{ color: "text.secondary", fontWeight: 600 }}>
      {title}
    </Typography>
    <InfoTip message={message} label={label} />
  </Box>
);

export default MethodInfo;
